import { enqueueSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useVincularCarcinogenicReportMutation } from '../../../services/carcinogenicApi';
import { useAppDispatch } from '../../../hooks/reduxHooks';
import { showAlert } from '../../../features/slices/applicationSlice';
import { ALERT_CONFIRM_TEXT, ERROR_CONTACT_SUPPORT } from '../../../constants/values';

const useCancerigenos = ({ refetchPresentations }: { refetchPresentations?: () => void }) => {
    const { t } = useTranslation('presentaciones');
    const [vincularReporte] = useVincularCarcinogenicReportMutation();
    const dispatch = useAppDispatch();

    const getSRTAuthTicket = async (): Promise<{ success: boolean }> => {
        return Promise.resolve({ success: true });
    };

    const sendCancerigenoToSRT = async (
        id: number
    ): Promise<{ success: boolean; error?: string }> => {
        try {
            await vincularReporte(id).unwrap();
            return { success: true };
        } catch (err: any) {
            const errorMessage = err?.data?.message || t('alerts.errors.srtServiceFailed');
            return { success: false, error: errorMessage };
        }
    };

    const handleApproveCancerigeno = useCallback(
        async (item: any) => {
            try {
                const ticketResponse = await getSRTAuthTicket();
                if (!ticketResponse?.success) {
                    enqueueSnackbar(t('alerts.errors.authSRTFailed'), { variant: 'error' });
                    return;
                }

                const approveResponse = await sendCancerigenoToSRT(item.id);
                if (!approveResponse?.success) {
                    enqueueSnackbar(approveResponse?.error || t('alerts.errors.srtServiceFailed'), {
                        variant: 'error'
                    });

                    return;
                }

                enqueueSnackbar(t('alerts.success.approved'), { variant: 'success' });
                refetchPresentations?.();
            } catch (error) {
                dispatch(
                    showAlert({
                        title: 'No se pudo aprobar el informe de cancerígenos',
                        message: ERROR_CONTACT_SUPPORT,
                        icon: 'error',
                        confirmText: ALERT_CONFIRM_TEXT
                    })
                );
            }
        },
        [t, refetchPresentations]
    );

    return {
        handleApproveCancerigeno
    };
};

export default useCancerigenos;
